import { useState } from "react";
import api from "../utils/axios";
import { useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import { GoogleLogin } from "@react-oauth/google";

// Admin-only login via Google Sign-In. Dealers no longer log in here — they
// use the SOTA app. Only allow-listed admin emails can sign in.
export default function Login() {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleGoogle = async (credentialResponse) => {
    const credential = credentialResponse?.credential;
    if (!credential) {
      toast.error("Google sign-in failed. Try again.");
      return;
    }
    setLoading(true);
    toast.loading("Signing in…", { id: "g" });
    try {
      const res = await api.post("/admin-auth/google", { credential });
      const admin = res.data?.admin;
      if (!res.data?.success || !admin) {
        toast.error(res.data?.message || "Not authorized", { id: "g" });
        setLoading(false);
        return;
      }
      // Store admin session (reuse "dealer" key so PrivateRoute keeps working).
      localStorage.setItem(
        "dealer",
        JSON.stringify({
          type: "admin",
          email: admin.email,
          name: admin.name,
          role: admin.role, // "super" | "admin"
        })
      );
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userType", "admin");
      localStorage.setItem("adminEmail", admin.email);
      localStorage.setItem("adminRole", admin.role);
      localStorage.setItem("loginTimestamp", Date.now().toString());

      toast.success(`Welcome ${admin.name || admin.email} 🎉`, { id: "g" });
      setTimeout(() => navigate("/admin-dashboard", { replace: true }), 600);
    } catch (err) {
      const message =
        err.response?.data?.message || "This email is not authorized.";
      toast.error(message, { id: "g" });
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-indigo-50 to-purple-50 flex items-center justify-center px-4 py-12">
      <div className="w-full max-w-md">
        <div className="bg-white rounded-2xl shadow-2xl overflow-hidden">
          <div className="bg-yellow-500 px-8 py-10 text-center">
            <img
              src="/images/logo.png"
              alt="Logo"
              className="h-40 w-40 mx-auto object-contain"
            />
            <p className="text-blue-900 mt-4 text-lg font-medium">Admin Login</p>
          </div>

          <div className="px-8 pb-10 pt-8">
            <p className="text-center text-sm text-gray-600 mb-6">
              Sign in with your authorized Google account.
            </p>

            <div className="flex justify-center">
              {loading ? (
                <div className="text-gray-500 font-medium py-3">Signing in…</div>
              ) : (
                <GoogleLogin
                  onSuccess={handleGoogle}
                  onError={() => toast.error("Google sign-in failed.")}
                  useOneTap={false}
                  shape="pill"
                  size="large"
                  text="signin_with"
                  width="280"
                />
              )}
            </div>

            <p className="text-center text-[12px] text-gray-400 mt-6">
              Only approved admin emails can access this dashboard. <br />
              Need access? Contact the owner.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
